<template>
  <div v-if="flag.ready">
    <div v-if="users.length">
      <div
        class="a4-page breakAfter"
        :class="$style.wrapper"
        v-for="user in users"
        :key="user.id">
        <Print :user="user" />
      </div>
    </div>
    <div v-else-if="flag.invalid">
      <p>URLが正しくないか、本ページを表示する権限がありません。</p>
      <p>アカウントタブから遷移してこの表示がされている場合は、<br>お手数ですが事務局までお知らせください。</p>
    </div>
    <div v-else>
      <p>仮登録中の該当利用者はいませんでした。</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Print from '@/views/components/Print.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'TcPrint',
  mixins: [cf],
  components: {
    Print,
  },
  data() {
    return {
      users: [],
      flag: {
        ready: false,
        invalid: false,
      },
    };
  },
  created() {
    this.showLoading();

    if (this.user.email) {
      this.getUsers();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/setUserData') {
          this.getUsers();
        }
      });
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** 仮登録のユーザー情報を取得 */
    getUsers() {
      let schoolId = null;
      if (this.user.account_type === 31) {
        // 事務局で開いた場合はパスパラメータ
        const params = this.$route.params;
        if (params.school_id) {
          schoolId = cf.convert2Num(params.school_id);
        }
      } else {
        // 学校管理者が開いた場合は自身の学校
        schoolId = this.user?.school?.[0]?.id || null;
      }

      if (!schoolId) {
        this.flag.invalid = true;
        this.flag.ready = true;
        this.hideLoading();
        return;
      }

      // 学校を絞り込んで仮登録ユーザの取得
      this.axios({
        method: 'GET',
        url: '/v1/user/get/searchGrant',
        params: {
          temporaryOnly: 1,
          school_id: schoolId,
        },
      })
        .then((response) => {
          this.users = response.data.users.data;
        })
        .catch((error) => {
          console.log(error.response?.data || error);
          this.flag.invalid = true;
        })
        .finally(() => {
          this.flag.ready = true;
          this.hideLoading();
        });
    },
  },

};
</script>

<style lang="scss" module>
.wrapper {
  // margin-bottom: 4em;
}
</style>
